import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cd6c05b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "work",
  "data-aos": "fade-left",
  "data-aos-easing": "ease"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Developed with", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.icon,
      alt: "App Image",
      height: "128",
      width: "128",
      "data-aos": "flip-left",
      "data-aos-easing": "ease"
    }, null, 8, _hoisted_2),
    _createElementVNode("a", {
      href: _ctx.link,
      target: "_blank",
      rel: "noopener noreferrer",
      "data-aos": "fade-up",
      "data-aos-easing": "ease"
    }, _toDisplayString(_ctx.name), 9, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", null, _toDisplayString(_ctx.details), 1)
    ]),
    _createElementVNode("ul", null, [
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.technology, (tech, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          "data-aos": "fade-up",
          "data-aos-easing": "ease"
        }, _toDisplayString(tech), 1))
      }), 128))
    ])
  ]))
}